<template>
    <div>
        <v-tooltip  top :attach="`#file-${file.id}`">
            <template v-slot:activator="{ on, attrs }">
                <v-row no-gutters  v-bind="attrs" v-on="on" >
                    <div style="position:relative" :id="'file-' + file.id">
                        <!-- Thumbnail for PDFs and images (the image itself until the API has made one); file-type icon otherwise -->
                        <DocumentThumbnail :document="file" :size="40" fallback="icon" />
                    </div>


                    <v-col class="ml-1" style="line-height: normal;">
                        <div>
                            <span class="text-overflow "  style="width: 130px;font-weight: 500;"> {{ file.fileName }}</span>
                        </div>
                        <div class="text-muted" style="font-size: smaller;">
                            {{ $formatFileSize(file.size, 2) }}
                        </div>
                    </v-col>
                </v-row>


            </template>
            <span>{{ file.fileName }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import DocumentThumbnail from '@/features/Documents/components/DocumentThumbnail.vue';

export default {
    components: { DocumentThumbnail },
    props: ['file']
}
</script>

<style>


</style>
